/*
 * Ruby Lookbook — Kategori filtresi (yatay, coklu secim)
 * -----------------------------------------------------------------
 * Tum kartlar ilk HTML icinde bulunur. Filtre yalnizca gorunurluk
 * degistirir; DOM'a kart eklenmez, sunucuya istek gitmez.
 * Kategori listesi lookbook_category metaobject kayitlarindan gelir;
 * bu dosyada hicbir kategori adi veya handle'i sabit degildir.
 *
 * Coklu secim kurallari:
 *   - Birden fazla kategori acikken VEYA (OR) mantigi uygulanir.
 *   - Aktif bir kategoriye tekrar tiklamak onu secimden cikarir.
 *   - "Tumu" butonu tum secimleri temizler.
 *   - Hicbir kategori secili degilse tum kartlar gorunur (yalnizca
 *     sezonluk kategoriye bagli olanlar haric — data-lookbook-seasonal-only).
 *
 * Sezonluk kategori (data-filter-exclusive, ornegin Yilbasi):
 *   - Tiklaninca diger tum secimler temizlenir, yalnizca o acilir;
 *     aciksa tekrar tiklamak onu kapatir ("Tumu").
 *   - O acikken normal bir kategoriye tiklanirsa sezonluk kapanir ve
 *     yalnizca tiklanan kategori acilir.
 *   - Adreste baskalariyla birlikte gelirse yalnizca o kalir.
 * URL parametresi: ?kategori=a,b,c
 * -----------------------------------------------------------------
 */
(function () {
  'use strict';

  var PARAM = 'kategori';

  /* "a,b" -> ["a","b"]; bos/yinelenen degerler atilir. */
  function parseList(raw) {
    if (!raw) return [];
    var out = [];
    var parts = String(raw).split(',');
    for (var i = 0; i < parts.length; i++) {
      var value = parts[i].trim();
      if (value && out.indexOf(value) === -1) out.push(value);
    }
    return out;
  }

  if (!window.customElements.get('lookbook-filters')) {
    window.customElements.define(
      'lookbook-filters',
      class LookbookFilters extends HTMLElement {
        connectedCallback() {
          this.options = Array.prototype.slice.call(
            this.querySelectorAll('[data-filter-option]')
          );
          this.grid = document.getElementById(this.dataset.gridId || '');
          this.statusEl = document.getElementById(this.dataset.statusId || '');

          if (!this.options.length || !this.grid) return;

          this.active = [];
          var exclusiveOption = this.querySelector('[data-filter-exclusive]');
          this.exclusive = exclusiveOption
            ? exclusiveOption.getAttribute('data-filter-option') || ''
            : '';
          this.allLabel = this.dataset.allLabel || 'Tümü';
          this.resultTemplate = this.dataset.resultTemplate || '{{ count }}';

          this.onOptionClick = this.onOptionClick.bind(this);
          this.onPopState = this.onPopState.bind(this);

          this.options.forEach(
            function (option) {
              option.addEventListener('click', this.onOptionClick);
            }.bind(this)
          );
          window.addEventListener('popstate', this.onPopState);

          /* Inline bootstrap script ilk boyamadan once uygulamis olabilir. */
          this.apply(parseList(this.grid.dataset.activeCategory), false);
        }

        disconnectedCallback() {
          window.removeEventListener('popstate', this.onPopState);
        }

        get validHandles() {
          return this.options
            .map(function (option) {
              return option.getAttribute('data-filter-option') || '';
            })
            .filter(Boolean);
        }

        onOptionClick(event) {
          event.preventDefault();
          var handle = event.currentTarget.getAttribute('data-filter-option') || '';

          /* "Tumu": tum secimleri temizler. */
          if (!handle) {
            this.apply([], true);
            return;
          }

          /* Sezonluk kategori tek basina acilir; aciksa kapanir ("Tumu"). */
          var exclusive = this.exclusive;
          if (exclusive && handle === exclusive) {
            this.apply(this.active.indexOf(handle) === -1 ? [handle] : [], true);
            return;
          }

          /* Normal kategori: sezonluk aciksa kapanir, coklu secim aynen surer. */
          var next = this.active.filter(function (active) {
            return active !== exclusive;
          });
          var index = next.indexOf(handle);
          if (index === -1) {
            next.push(handle);
          } else {
            next.splice(index, 1);
          }
          this.apply(next, true);
        }

        onPopState() {
          var params;
          try {
            params = new URLSearchParams(window.location.search);
          } catch (e) {
            return;
          }
          this.apply(parseList(params.get(PARAM)), false);
        }

        /* Gecersiz veya silinmis kategoriler sessizce atilir. */
        normalize(handles) {
          var valid = this.validHandles;
          var out = (handles || []).filter(function (handle) {
            return valid.indexOf(handle) !== -1;
          });
          /* Sezonluk kategori baskalariyla birlikte gelirse yalnizca o kalir. */
          if (this.exclusive && out.indexOf(this.exclusive) !== -1) return [this.exclusive];
          return out;
        }

        apply(rawHandles, updateUrl) {
          var handles = this.normalize(rawHandles);
          this.active = handles;

          var items = this.grid.querySelectorAll('[data-lookbook-item]');
          var visible = 0;

          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            /* "Tumu": yalnizca sezonluk kategoriye bagli konseptler haric. */
            var match = handles.length === 0 && !item.hasAttribute('data-lookbook-seasonal-only');

            if (!match) {
              var haystack = ' ' + (item.getAttribute('data-categories') || '') + ' ';
              /* OR: kartin kategorilerinden herhangi biri secilmisse gosterilir. */
              for (var j = 0; j < handles.length; j++) {
                if (haystack.indexOf(' ' + handles[j] + ' ') !== -1) {
                  match = true;
                  break;
                }
              }
            }

            item.classList.toggle('is-match', match);
            item.hidden = !match;
            if (match) visible++;
          }

          this.grid.dataset.activeCategory = handles.join(',');
          this.grid.classList.toggle('lookbook-grid--filtered', handles.length > 0);

          this.options.forEach(function (option) {
            var optionHandle = option.getAttribute('data-filter-option') || '';
            var isActive = optionHandle
              ? handles.indexOf(optionHandle) !== -1
              : handles.length === 0;
            option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            option.classList.toggle('is-active', isActive);
          });

          if (this.statusEl) {
            /* Liquid ceviriye __COUNT__ yer tutucusu gecirir. */
            this.statusEl.textContent = this.resultTemplate
              .replace(/__COUNT__/g, String(visible))
              .replace(/\{\{\s*count\s*\}\}/g, String(visible));
          }

          if (updateUrl) this.syncUrl(handles);
        }

        syncUrl(handles) {
          if (!window.history || !window.history.replaceState) return;
          var url;
          try {
            url = new URL(window.location.href);
          } catch (e) {
            return;
          }
          if (handles.length) {
            url.searchParams.set(PARAM, handles.join(','));
          } else {
            url.searchParams.delete(PARAM);
          }
          window.history.replaceState({ kategori: handles.join(',') }, '', url.toString());
        }
      }
    );
  }
})();
